<template>
    <!--Client Waiting List Page-->
    <div class="client-step4">
        <!--Step Four-->
        <div class="client-step4-wrap section-wrap">
            <!--Subtitle-->
            <h5>{{ $ml.get("waitingList.title") }} - {{ currentWaitingListStylist.first_name }}, {{
                currentWaitingListStylist.last_name }}</h5>
            <div class="steps">
                <p class="highlight-text">{{ $ml.get("waitingListClient.stepOne") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $ml.get("waitingListClient.stepTwo") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $ml.get("waitingListClient.stepThree") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $ml.get("waitingListClient.stepFour") }}</p>
            </div>
            <div class="client-step4-wrap" v-if="!loading">
                <p class="section-wrap">
                    {{ $ml.get("waitingListClient.stepFourParagraph") }}
                </p>
                <div class="next-btn">
                    <button type="button" class="primary-btn extra-small mobile" 
                        @click="handleSaveClientWaitlistSettings">
                        {{ $ml.get("general.continue") }}
                    </button>
                    <button type="button" class="secondary-btn small mobile" @click="changeSection('client-step3')">
                        {{ $ml.get("general.goBack") }}
                    </button>
                </div>
            </div>
            <main-loader v-if="loading"></main-loader>
        </div>
    </div>
</template>

<script>
import store from "../../../../../services/vuex";
import api from "../../../../../services/api_endpoints";
import messages from "../../../../../services/messages";
import MainLoader from "../../../general-components/main_loader.vue";

export default {
    data() {
        return {
            notificationTime: '',
            loading: false,
            completed: 0,
        };
    },
    computed: {
        currentWaitingListStylist: {
            get: function () {
                return store.state.currentWaitingListStylist;
            },
            set: function (value) {
                store.commit("setCurrentWaitingListStylist", value);
            },
        },
    },
    mounted() {
        this.getClientWaitlistSettings(this.currentWaitingListStylist.id);
    },
    components: { MainLoader },
    methods: {
        changeSection(section) {
            this.$emit('change-section', section);
        },
        handleSaveClientWaitlistSettings() {
            this.saveClientWaitlistSettings();
            this.changeSection('client-final-step');
        },
        saveClientWaitlistSettings() {
            this.notificationTime = 'immediately';
            this.completed = 1;

            let data = {
                stylist_id: this.currentWaitingListStylist.id,
                send_time: this.notificationTime,
                completed: this.completed,
            };

            this.$http.post(api.actions.save_client_waitlist_settings, data).then((response) => {

                if (response.data.error == true) {
                    return;
                }

                this.getClientWaitlistSettings(this.currentWaitingListStylist.id);
            });
            return;
        },
        getClientWaitlistSettings(stylistId) {
            this.loading = true;

            this.$http.get(api.actions.get_client_waitlist_settings + "/" + stylistId).then(
                function (response) {
                    if (response.data.error == true) {
                        return;
                    }

                    this.notificationTime = response.data.settings.send_time;
                    this.loading = false;

                }.bind(this)
            );
        },
    },
};
</script>
